import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import { patientsIconDark, labsIconDark, labtestIconDark } from './Images';
import CardMenu from './CardMenu';

const HomeMenu = () => {

    const menuOptions = [
        { image : patientsIconDark, url : '/patients', name:'Pacientes', description:['Consulta pacientes','Crea pacientes'] }
        ,{ image : labsIconDark, url : '/laboratorios', name:'Laboratorios', description: ['Agenda pruebas de laboratorio']}
        ,{ image : labtestIconDark, url : '/lab-tests', name:'Pruebas de Laboratorio', description: ['Haz seguimiento de las pruebas de laboratorio']}
    ]

    return (
        <>
            <div className="home-menu row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3 row-cols-xl-4">
                {menuOptions.map((item, index) => (
                    <div className='col d-flex flex-column' key={index}>
                        <CardMenu 
                            image={item.image}
                            redirect={item.url} 
                            name={item.name} 
                            description={item.description} 
                        />
                    </div>
                ))}
            </div>
        </>
    );
}

export default HomeMenu;
